import type { Example } from '../types';

export const ghostTransparencyExample: Example = {
  id: 'ghost-transparency',
  title: 'Ghost & Transparency',
  categoryId: 'viewer',
  description: 'See inside objects — ghost and transparent render modes',
  scadCode: `/* Ghost & Transparency */

// markdown:tip
// **Ghost & Transparency** — Prefix any object with \`~\` (ghost) to render
// it as a see-through overlay, excluded from STL export. Use
// \`transparent=true\` in \`material_def()\` for alpha-blended transparency.
// Try switching between **ghost**, **transparent**, and **solid** below.

/* [Enclosure] */

// Outer shell size
shell_size = 60; // [30:1:100]

// Wall thickness
wall = 4; // [1:0.5:10]

// Shell display mode
shell_mode = "ghost"; // [ghost, transparent, solid]

// Shell color
// color
shell_color = [0.3, 0.55, 0.8];

// Shell opacity (transparent mode)
shell_opacity = 0.25; // [0.05:0.05:0.8] {shell_mode == "transparent"}

/* [Interior] */

// Show interior geometry?
show_interior = true;

// Interior color
// color
interior_color = [0.9, 0.5, 0.15];

// --- parameters end ---

half = shell_size / 2;

module shell_geometry() {
  difference() {
    cube([shell_size, shell_size, shell_size], center=true);
    cube([shell_size - wall*2, shell_size - wall*2, shell_size - wall*2], center=true);
    // Cut-away window on front face so interior is visible in solid mode
    translate([0, -half, 0])
      cube([shell_size * 0.5, wall * 3, shell_size * 0.5], center=true);
  }
}

// Shell — ghost, transparent, or solid
if (shell_mode == "ghost") {
  color(shell_color) ~shell_geometry();
} else if (shell_mode == "transparent") {
  color(shell_color)
  material(material_def(transparent=true, opacity=shell_opacity))
    shell_geometry();
} else {
  color(shell_color)
    shell_geometry();
}

// Interior assembly
if (show_interior) {
  // Central sphere
  color(interior_color)
    sphere(r=shell_size * 0.18, $fn=48);

  // Three small satellite cubes
  color([0.7, 0.3, 0.3])
  for (a = [0, 120, 240])
    rotate([0, 0, a])
    translate([shell_size * 0.22, 0, 0])
      cube([8, 8, 8], center=true);

  // Vertical rod
  color([0.6, 0.6, 0.65])
    cylinder(d=4, h=shell_size * 0.7, center=true, $fn=16);
}
`,
};
